import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectRegistrationTotals } from "../../../redux/slices/registrationSlice";
import PrivacyOptions from "./PrivacyOptions";

const ConnectedPrivacyOptions = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const isCms = useSelector(selectIsCms);
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );
    const {
        options: {
            sectionHeading = "Privacy Options",
            additionalText = "",
            displayPrivacyNameCheckboxLabel = "Show my name as a supporter on public campaign pages",
            displayPrivacyAmountCheckboxLabel = "Show amount of my support on public campaign pages",
        },
    } = control;
    const {
        includePurchasesInGoal,
        enableOptionalDonation,
        displayAnonymousDonorInformation,
    } = useSelector(selectAllP2pSettings);
    const { optionalDonationAmount = 0.0, storeSubtotalAmount = 0.0 } =
        useSelector(selectRegistrationTotals);

    const includePurchases = includePurchasesInGoal && storeSubtotalAmount > 0;
    const includeDonations =
        enableOptionalDonation && optionalDonationAmount > 0;

    const getPrivacyAmountTooltipByState = (recipients) => {
        const placeholder = "%TYPE%";
        const tooltip = `The amount of your ${placeholder} is always shared with the ${recipients} and payment processor.`;
        const donation = "gift";
        const purchase = "purchase";

        if (includePurchases && includeDonations) {
            return tooltip.replace(placeholder, `${donation} and ${purchase}`);
        }
        if (includeDonations) {
            return tooltip.replace(placeholder, donation);
        }
        if (includePurchases) {
            return tooltip.replace(placeholder, purchase);
        }
        return tooltip.replace(placeholder, "support");
    };

    let recipients = "organization";
    if (displayAnonymousDonorInformation) {
        recipients = "recipient, organization,";
    }

    // set the tooltip text
    const privacyNameTooltip = `Your name is always shared with the ${recipients} and payment processor.`;
    const privacyAmountTooltip = getPrivacyAmountTooltipByState(recipients);
    // set whether to display
    const displayPrivacyOptions = includePurchases || includeDonations || isCms;

    const privacyOptionsProps = {
        sectionHeading,
        additionalText,
        displayPrivacyNameCheckboxLabel,
        displayPrivacyAmountCheckboxLabel,
        privacyNameTooltip,
        privacyAmountTooltip,
        displayPrivacyOptions,
    };
    return <PrivacyOptions {...privacyOptionsProps} />;
};

ConnectedPrivacyOptions.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedPrivacyOptions;
